import React, { useCallback, useState, useEffect, useRef } from 'react';
import 'survey-core/defaultV2.min.css';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import { useSelector } from 'react-redux';
import { Modal, Button, Table, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import useSurveyTemplate from '../../hooks/useSurveyTemplate';
import useContenutiUtenti from '../../hooks/useContenutiUtenti';//NEW

function QuizExecutionPage() {
    const [showResults, setShowResults] = useState(false);
    const [quizResults, setQuizResults] = useState(null);
    const [loading, setLoading] = useState(true);
    const [surveyData, setSurveyData] = useState(null);
    const [countdown, setCountdown] = useState(3);
    const [showQuiz, setShowQuiz] = useState(false);
    const user = useSelector(state => state.user?.userData);
    const location = useLocation();
    const navigate = useNavigate();
    const { classeData, selectedContenuto } = location.state || {};
    const { getSurveyTemplateByIdContenuto } = useSurveyTemplate();
    const { salvaTest } = useContenutiUtenti();

    useEffect(() => {
        loadSurveyTemplate();
    }, []);

    useEffect(() => {
        if (surveyData && countdown > 0) {
            const timer = setInterval(() => {
                setCountdown(prev => prev - 1);
            }, 1000);

            return () => clearInterval(timer);
        }
        
        if (countdown === 0) {
            setShowQuiz(true);
        }
    }, [countdown, surveyData]);

    const loadSurveyTemplate = async () => {
        try {
            const template = await getSurveyTemplateByIdContenuto({ id_contenuto: selectedContenuto.id_contenuto });
            if (template) {
                setSurveyData(JSON.parse(template.json_definition));
            }
        } catch (error) {
            console.error('Errore nel caricamento del template:', error);
        } finally {
            setLoading(false);
        }
    };

    const alertResults = useCallback((sender) => {
        let totalScore = 0;
        let maxPossibleScore = 0;
        
        const detailedResults = sender.getAllQuestions().map(question => {
            const questionScore = question.score || 1;
            maxPossibleScore += questionScore;
            
            const isCorrect = question.correctAnswer === sender.data[question.name];
            if (isCorrect) {
                totalScore += questionScore;
            }

            return {
                title: question.title,
                userAnswer: sender.data[question.name] || 'Non risposto',
                correctAnswer: question.correctAnswer,
                isCorrect: isCorrect,
                score: questionScore
            };
        });

        const timeInSeconds = Math.round(sender.timeSpent || 0);
        const timeInMinutes = Math.ceil(timeInSeconds / 60);

        setQuizResults({
            summary: {
                totalQuestions: sender.getAllQuestions().length,
                correctAnswers: detailedResults.filter(r => r.isCorrect).length,
                score: totalScore,
                maxScore: maxPossibleScore,
                timeSpent: timeInMinutes,
                percentage: Math.round((totalScore / maxPossibleScore) * 100)
            },
            details: detailedResults
        });

        setShowResults(true);
    }, [user]);

    const hasSavedTest = useRef(false);//NEW
    useEffect(() => {//NEW
        if (quizResults?.summary?.correctAnswers >= 18 && !hasSavedTest.current) {
            hasSavedTest.current = true;
            savePositiveTest(selectedContenuto.id_contenuto, quizResults);
        }
    }, [quizResults, selectedContenuto?.id_contenuto]);

    const savePositiveTest = (idContenuto, quizResults) => {//NEW
        try {
            const resultSaving = salvaTest({ id_contenuto: idContenuto, test_data: quizResults });
        } catch (error) {
            console.error('Errore nel salvataggio del test:', error);
        }
        finally {
            setLoading(false);
        }
    };

    const ResultsView = () => {
        if (!quizResults) return null;
        var testSuperato = false;
        if(quizResults.summary.correctAnswers >= 18){
            testSuperato = true;
        }
        
        return (
            <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h2 className="display-4 mb-3">
                            {quizResults.summary.percentage >= 60 ? 'Ottimo lavoro!' : 'Continua a studiare!'}
                        </h2>
                        <p className="lead text-muted">
                            {quizResults.summary.percentage >= 60 
                                ? 'Hai superato il test con successo!' 
                                : 'Non mollare, puoi fare di meglio!'}
                        </p>
                    </div>

                    {/* Circular Progress */}
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-4 text-center">
                            <div className="position-relative d-inline-block">
                                <svg width="200" height="200" viewBox="0 0 200 200">
                                    <circle
                                        cx="100"
                                        cy="100"
                                        r="90"
                                        fill="none"
                                        stroke="#e9ecef"
                                        strokeWidth="12"
                                    />
                                    <circle
                                        cx="100"
                                        cy="100"
                                        r="90"
                                        fill="none"
                                        stroke={quizResults.summary.percentage >= 60 ? '#28a745' : '#dc3545'}
                                        strokeWidth="12"
                                        strokeDasharray={`${2 * Math.PI * 90}`}
                                        strokeDashoffset={`${2 * Math.PI * 90 * (1 - quizResults.summary.percentage / 100)}`}
                                        style={{ transition: 'stroke-dashoffset 1s ease-in-out' }}
                                        transform="rotate(-90 100 100)"
                                    />
                                </svg>
                                <div 
                                    className="position-absolute" 
                                    style={{ 
                                        top: '50%', 
                                        left: '50%', 
                                        transform: 'translate(-50%, -50%)' 
                                    }}
                                >
                                    <h1 className={`display-4 mb-0 ${
                                        quizResults.summary.percentage >= 60 ? 'text-success' : 'text-danger'
                                    }`}>
                                        {quizResults.summary.percentage}%
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Stats Cards */}
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-8">
                            <div className="row g-4">
                                <div className="col-md-4">
                                    <div className="p-4 rounded-4 bg-white text-center h-100" style={{ boxShadow: '0 0.125rem 0.25rem rgba(0,0,0,0.075)' }}>
                                        <i className="bi bi-trophy-fill text-warning display-5 mb-3"></i>
                                        <h5>Punteggio</h5>
                                        <h3 className="text-primary mb-0">{quizResults.summary.score}/{quizResults.summary.maxScore}</h3>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="p-4 rounded-4 bg-white text-center h-100" style={{ boxShadow: '0 0.125rem 0.25rem rgba(0,0,0,0.075)' }}>
                                        <i className="bi bi-check2-circle text-success display-5 mb-3"></i>
                                        <h5>Risposte Corrette</h5>
                                        <h3 className="text-success mb-0">{quizResults.summary.correctAnswers}/{quizResults.summary.totalQuestions}</h3>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="p-4 rounded-4 bg-white text-center h-100" style={{ boxShadow: '0 0.125rem 0.25rem rgba(0,0,0,0.075)' }}>
                                        <i className="bi bi-clock-fill text-info display-5 mb-3"></i>
                                        <h5>Tempo</h5>
                                        <h3 className="text-info mb-0">{quizResults.summary.timeSpent} min</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Answers Table */}
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="bg-white rounded-4 p-5" style={{ boxShadow: '0 0.125rem 0.25rem rgba(0,0,0,0.075)' }}>
                                <h4 className="mb-4">Dettaglio Risposte</h4>
                                <div className="table-responsive">
                                    <table className="table table-borderless mb-0 align-middle">
                                        <thead>
                                            <tr className="border-bottom">
                                            <th style={{ width: '40%' }}>Domanda</th>
                                            <th style={{ width: testSuperato ? '30%' : '50%' }}>Tua Risposta</th>
                                            {testSuperato && <th style={{ width: '30%' }}>Risposta Corretta</th>}
                                            <th className="text-end" style={{ width: '10%' }}>Punti</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {quizResults.details.map((result, index) => (
                                            <tr key={index} className="border-bottom">
                                                <td>{result.title}</td>
                                                <td>
                                                <div className="d-flex align-items-center">
                                                    <i className={`bi ${
                                                    result.isCorrect 
                                                        ? 'bi-check-circle-fill text-success' 
                                                        : 'bi-x-circle-fill text-danger'
                                                    } me-2`}></i>
                                                    {result.userAnswer}
                                                </div>
                                                </td>
                                                {testSuperato && <td>{result.correctAnswer}</td>}
                                                <td className="text-end">{result.isCorrect ? result.score : 0}/{result.score}</td>
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center gap-3 mt-5">
                                <Button 
                                    variant="primary" 
                                    size="lg"
                                    onClick={() => window.location.reload()}
                                >
                                    <i className="bi bi-arrow-repeat me-2"></i>
                                    Riprova
                                </Button>
                                <Button 
                                    variant="outline-dark" 
                                    size="lg"
                                    onClick={() => navigate(-1)}
                                >
                                    <i className="bi bi-arrow-left me-2"></i>
                                    Torna al Corso
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const CountdownView = () => (
        <div style={{ 
            backgroundColor: '#f8f9fa', 
            minHeight: '100vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
        }}>
            <div className="text-center">
                <h3 className="mb-4 text-muted">
                    Il test sta per iniziare...
                </h3>
                <div 
                    className="display-1 fw-bold"
                    style={{ 
                        color: countdown === 1 ? 'orange' : 
                               countdown === 2 ? 'orange' : 'orange',
                        transition: 'all 0.3s ease-in-out',
                        transform: 'scale(1.2)',
                        animation: 'pulse 1s infinite'
                    }}
                >
                    {countdown}
                </div>
                <p className="mt-3 text-muted">
                    Preparati a rispondere alle domande
                </p>
            </div>
        </div>
    );

    if (loading) {
        return (
            <div style={{ 
                backgroundColor: '#f8f9fa', 
                minHeight: '100vh', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' 
            }}>
                <div className="text-center">
                    <Spinner 
                        animation="border" 
                        role="status"
                        style={{ width: '3rem', height: '3rem' }}
                        className="text-primary mb-3"
                    >
                        <span className="visually-hidden">Caricamento test...</span>
                    </Spinner>
                    <h5 className="text-muted">Caricamento test...</h5>
                </div>
            </div>
        );
    }

    if (!surveyData) {
        return (
            <div className="text-center p-5">
                <h4>Nessun test disponibile per questo contenuto</h4>
                <Button className='mt-3' variant="primary" onClick={() => navigate(-1)}>Torna al corso</Button>
            </div>
        );
    }

    const survey = new Model(surveyData);
    survey.onComplete.add(alertResults);
    
    survey.showCompletedPage = true;
    survey.completedHtml = "Grazie per aver completato il test!";
    survey.showProgressBar = "bottom";
    survey.showTimerPanel = "top";
    survey.maxTimeToFinish = surveyData.maxTimeToFinish;
    survey.maxTimeToFinishPage = surveyData.maxTimeToFinishPage;
    
    survey.completeText = "Completa";

    const style = document.createElement('style');
    style.textContent = `
        @keyframes pulse {
            0% { transform: scale(1.2); }
            50% { transform: scale(1.5); }
            100% { transform: scale(1.2); }
        }

        .table-responsive {
            overflow-x: hidden !important;
        }

        .table td {
            max-width: 200px;
            white-space: normal !important;
            word-wrap: break-word;
        }

        .table th:last-child,
        .table td:last-child {
            width: 80px;
            text-align: right;
        }

        .table th:first-child,
        .table td:first-child {
            width: 30%;
        }

        .table th:nth-child(2),
        .table td:nth-child(2),
        .table th:nth-child(3),
        .table td:nth-child(3) {
            width: 30%;
        }
    `;
    document.head.appendChild(style);

    return (
        <>
            {!showQuiz ? (
                <CountdownView />
            ) : !showResults ? (
                <Survey model={survey} />
            ) : (
                <ResultsView />
            )}
        </>
    );
}

export default QuizExecutionPage;

